// import React from 'react';
// import { Check } from 'lucide-react';
// import './CampaignProgress.css';

// const CampaignProgress = ({ currentStep, steps, onStepClick }) => {
//     return (
//         <div className="campaign-progress">
//             <div className="progress-steps">
//                 {steps.map((step, index) => (
//                     <React.Fragment key={step.number}>
//                         <div
//                             className="progress-step"
//                             onClick={() => onStepClick(step.number)}
//                         >
//                             <div className={`progress-circle 
//                 ${currentStep > step.number ? 'completed' : ''}
//                 ${currentStep === step.number ? 'active' : ''}
//               `}>
//                                 {currentStep > step.number ? <Check size={20} /> : step.number}
//                             </div>
//                             <span className={`progress-label 
//                 ${currentStep >= step.number ? 'active' : ''}
//               `}>
//                                 {step.label}
//                             </span>
//                         </div>
//                         {index < steps.length - 1 && (
//                             <div className={`progress-line 
//                 ${currentStep > step.number ? 'filled' : ''}
//               `} />
//                         )}
//                     </React.Fragment>
//                 ))}
//             </div>
//         </div>
//     );
// };

// export default CampaignProgress;







import React from "react";
import { Check, ArrowLeft } from "lucide-react";
import "./CampaignProgress.css";

const CampaignProgress = ({
    currentStep,
    steps,
    onStepClick,
    onBack,
    isDiscount
}) => {

    // Hide Medium & Media step for Discount / BOGO / Combo
    const visibleSteps = isDiscount
        ? steps.filter(step => step.number !== 2)
        : steps;

    return (
        <div className="campaign-progress">

            <div className="progress-steps">

                {visibleSteps.map((step, index) => (

                    <React.Fragment key={step.number}>

                        {step.number === 1 ? (

                            <div
                                className="progress-step"
                                onClick={onBack}
                                style={{ cursor: "pointer" }}
                            >
                                <div className="progress-circle active">
                                    <ArrowLeft size={18} />
                                </div>

                                <span className="progress-label active">
                                    Back
                                </span>
                            </div>

                        ) : (

                            <div
                                className="progress-step"
                                onClick={() => onStepClick(step.number)}
                                style={{ cursor: "pointer" }}
                            >
                                <div
                                    className={`progress-circle
                                        ${currentStep > step.number ? "completed" : ""}
                                        ${currentStep === step.number ? "active" : ""}
                                    `}
                                >
                                    {currentStep > step.number
                                        ? <Check size={18} />
                                        : step.number}
                                </div>

                                <span
                                    className={`progress-label
                                        ${currentStep >= step.number ? "active" : ""}
                                    `}
                                >
                                    {step.label}
                                </span>
                            </div>

                        )}

                        {index < visibleSteps.length - 1 && (
                            <div
                                className={`progress-line
                                    ${currentStep > step.number ? "filled" : ""}
                                `}
                            />
                        )}

                    </React.Fragment>

                ))}

            </div>

        </div>
    );
};

export default CampaignProgress;